/**
 * Customizations:
 *   - Added HDM_CHECK_OUT_STEP to STEPS.
 */

import { CardFormData } from '@/components/content/CheckOutV2/parts/PaymentMethods/paymentMethodSelection/paymentUtils';
import { EditableAddress } from '@/data/types/Address';
import { BOPIS_CHECK_OUT_STEP, CHECK_OUT_STEP, HDM_CHECK_OUT_STEP } from '@/data/types/CheckOut';
import { INewCardEntry } from '@/data/types/CyberSource';

export * from 'integration/data/core/constants/checkout';

export const STEPS: Record<
	CHECK_OUT_STEP | BOPIS_CHECK_OUT_STEP | HDM_CHECK_OUT_STEP,
	CHECK_OUT_STEP | BOPIS_CHECK_OUT_STEP | HDM_CHECK_OUT_STEP
> = {
	shipping: 'shipping',
	payment: 'payment',
	review: 'review',
	pickup: 'pickup',
	'pickup-store': 'pickup-store',
	hdmDeliveryContact: 'hdmDeliveryContact',
	hdmDeliveryDetails: 'hdmDeliveryDetails',
	hdmPaymentMethod: 'hdmPaymentMethod',
};

export const CHECK_OUT_STEPS: (CHECK_OUT_STEP | BOPIS_CHECK_OUT_STEP | HDM_CHECK_OUT_STEP)[] = [
	STEPS.hdmDeliveryContact,
	STEPS.hdmDeliveryDetails,
	STEPS.hdmPaymentMethod,
];

// NOTE: uuid taken from original react code.
export const PAYPAL_UUID_FRAGMENT = 'cbs9de39fe-c24d-11eb-8529-';

export const IGNORED_PAYPAL_BUTTON_ERRORS = ['Detected popup close', 'Window is closed'];

export const DEFAULT_ADDRESS_FORM: EditableAddress = {
	firstName: '',
	lastName: '',
	addressLine1: '',
	addressLine2: '',
	addressLine3: '',
	field1: '',
	field3: '',
	city: '',
	country: '',
	state: '',
	zipCode: '',
	phone1: '',
	nickName: '',
	email1: '',
	addressType: 'Billing',
};

export const FETCH_MSI_FOR_PRODUCTS = 'fetchMSIForProducts';

export const DEFAULT_UI_STATE = {
	isOrderProcessing: false,
	isSaveCurrentCard: false,
	isBillingAddressInEditMode: false,
	isProcessingNewCardFormSubmit: false,
	deleteCardId: '',
	// expDateSavedCard: '',
	newBillingAddressOnAMEX: false,
	isShowCardForm: false,
};

const EMPTY_DATE = '  /  ';

export const DEFAULT_FORM_VALIDATION_STATE = {
	isValidCC: false,
	isEmptyCC: true,
	isValidCVV: false,
	isEmptyCVV: true,
	isCardFormValid: false,
	expDateEmptyInput: false,
	touched: {
		cardNum: false,
		expDate: false,
		cvv: false,
		firstName: false,
		lastName: false,
	},
};
export const DEFAULT_CARD_FORM_DATA: CardFormData = {
	expDate: EMPTY_DATE,
	firstName: '',
	lastName: '',
};
export const DEFAULT_DIALOGS_STATE = {
	timer: false,
	deleteCard: false,
	threeDS: false,
	incorrectOrder: false,
	open: false,
};
export const DEFAULT_CARD_ENTRY_DATA: INewCardEntry = {
	cardHolderName: '',
	expDate: '',
};
export enum SELECTION_STATE {
	NONE = 'none',
	NEW_CARD = 'new',
	SAVED_CARD = 'saved',
}
// Removed 'g' flag to avoid stateful lastIndex issues when reused.
export const NAME_VALIDATION_PATTERN = /^[A-Za-zñÑáéíóúÁÉÍÓÚ0´\s]+$/;
export const MICROFORM_TIMER_DURATION = 15 * 60 * 1000; // 15 minutes

export const FLOW_TYPES = {
	REGISTERED: 'registered',
	GUEST: 'guest',
};

export const ITEM_DELIVERY_TYPE: { PARCEL: 'Parcel'; FLEET: 'Fleet' } = {
	PARCEL: 'Parcel',
	FLEET: 'Fleet',
};

// Values the transaction server stores in XORDERITEMS.SAMEDAY
export const SAME_DAY_FLAG: { YES: 'Y'; NO: 'N' } = {
	YES: 'Y',
	NO: 'N',
};
